import {capitalize, toArray} from 'lodash-es';
import {
  ActionType,
  CheckboxGroupField,
  RadioGroupField,
} from '../../components/AutoForm/AutoFieldNew';
import {
  GlobalPermissionEnum,
  PermGroupsEnum,
  UserPermissionEnum,
} from '../../schema-types/globalTypes';

export const additionalPermissionsField: CheckboxGroupField = {
  type: ActionType.checkboxGroup,
  fullWidth: true,
  options: [
    {
      value: UserPermissionEnum.can_access_api_features,
      label: 'Can access API features',
    },
    {
      value: UserPermissionEnum.can_access_oneview,
      label: 'Can access Oneview',
    },
    {
      value: UserPermissionEnum.can_access_admin_features,
      label: 'Can access Admin features',
    },
    {
      value: UserPermissionEnum.can_change_business_unit,
      label: 'Can change Business Unit',
    },
  ],
  horizontal: true,
  horizontalOptionWidthXs: 4,
  horizontalOptionWidthMd: 3,
  horizontalOptionWidthLg: 3,
  id: 'permissions',
  label: 'Additional permissions',
};

export const permissionsFieldValues = additionalPermissionsField.options.map((x) =>
  String(x.value)
);

const getGroupNameLabel = (permEnum: string) => {
  let label = permEnum;
  if (label.includes('junior') || label.includes('senior')) {
    label += ' adviser';
  }
  return label.replaceAll('_', ' ').toLocaleUpperCase();
};

export const groupNameField: RadioGroupField = {
  type: ActionType.radioGroup,
  options: [
    ...Object.keys(PermGroupsEnum).map((x) => ({
      value: x,
      label: getGroupNameLabel(x),
    })),
  ],
  id: 'groupName',
  label: 'Select user group',
  horizontal: true,
};

const globalPermissionsFieldOptions = toArray(GlobalPermissionEnum)
  .filter((x) => !Object.values(UserPermissionEnum).includes(x as any))
  .map<CheckboxGroupField['options'][0]>((x) => ({
    label: capitalize(
      x
        .replaceAll('_', ' ')
        .toLocaleLowerCase()
        .replace('can access ', '')
        .replace(/\bfe\b/, '')
    ),
    value: x,
    capitalise: true,
  }));

export const globalPermissionsField: CheckboxGroupField = {
  type: ActionType.checkboxGroup,
  options: globalPermissionsFieldOptions,
  readOnly: true,
  disabled: true,
  fullWidth: true,
  id: 'featurePermissions',
  label: 'Feature permissions (not editable)',
  horizontal: true,
  horizontalOptionWidthXs: 4,
  horizontalOptionWidthMd: 3,
  horizontalOptionWidthLg: 3,
};
